import OImage from "components/reusable/OImage";
import Toolbar from "components/Toolbar";
import { saveAs } from "file-saver";
import { Button } from "flowbite-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { apiGet } from "utils/apiFetch";
import pathObj from "utils/apiPath";

const MyQrCode = () => {
  const { t } = useTranslation();
  const [qrCode, setQrCode] = useState("");

  const getCustomerQR = async () => {
    try {
      const res = await apiGet(pathObj.customerQrCode);
      setQrCode(res.data.results);
    } catch (error) {}
  };

  useEffect(() => {
    getCustomerQR();
  }, []);
  const downloadImage = (image) => {
    saveAs(image, "QRcode.png");
  };
  return (
    <>
      <Toolbar title={t('O_MY_QR_CODE')} showBackBtn={true} />
      <div className="flex flex-col justify-center items-center h-full">
        <OImage src={qrCode} style={{ width: "250px", height: "250px", marginBottom: "20px" }} alt="qr code" />
        <Button onClick={() => downloadImage(qrCode)} className="bg-primary text-white ms-xl-3 ms-sm-2 mt-xl-0 mt-sm-2 cursor-pointer">
          {t("SHARE_QR_CODE")}
        </Button>
      </div>
    </>
  );
};

export default MyQrCode;
